import {
	CSSProperties,
} from 'react';

import PickupSvg from '../../assets/img/app.pickup.svg';
import PickupDoneSvg from '../../assets/img/app.pickup_done.svg';
import DeliverySvg from '../../assets/img/app.delivery.svg';
import DeliveryDoneSvg from '../../assets/img/app.delivery_done.svg';
import ElectricalSvg from '../../assets/img/app.electrical.svg';
import ElectricalDone from '../../assets/img/app.electrical_done.svg';
import HighPrioritySvg from '../../assets/img/app.high_priority.svg';
import HighPriorityDone from '../../assets/img/app.high_priority_done.svg';
import DeviationSvg from '../../assets/img/app.deviation.svg';
import DeviationDoneSvg from '../../assets/img/app.deviation_done.svg';

import LoadingWheelSvg from '../../assets/img/app.loading_wheel.svg';
import CameraSvg from '../../assets/img/app.camera.svg';
import DoneSvg from '../../assets/img/app.done.svg';
import DoneNoCircleSvg from '../../assets/img/app.done_no_circle.svg';
import AppIconSvg from '../../assets/img/app.icon.svg';
import MenuBurgerSvg from '../../assets/img/app.menu_burger.svg';

export interface SvgProps {
	alt?: string,
	title?: string,
	className?: string,
	style?: CSSProperties;
}

export interface SvgPropsDone extends SvgProps {
	done?: boolean,
}

// Svg with don/gray versions
export const SvgPickup = (props: SvgPropsDone) => <Svg svg={!props.done ? PickupSvg : PickupDoneSvg} {...props} />;
export const SvgDelivery = (props: SvgPropsDone) => <Svg svg={!props.done ? DeliverySvg : DeliveryDoneSvg} {...props} />;
export const SvgElectrical = (props: SvgPropsDone) => <Svg svg={!props.done ? ElectricalSvg : ElectricalDone} {...props} />;
export const SvgHighPriority = (props: SvgPropsDone) => <Svg svg={!props.done ? HighPrioritySvg : HighPriorityDone} {...props} />;
export const SvgDeviation = (props: SvgPropsDone) => <Svg svg={!props.done ? DeviationSvg : DeviationDoneSvg} {...props} />;
//export const SvgDangerGoods = (props: SvgPropsDone) => <Svg svg={!props.done ? 'danger_goods' : 'danger_goods_done'} {...props} />;

// Svg plain
export const SvgLoadingWheel = (props: SvgProps) => <Svg svg={LoadingWheelSvg} {...props} />;
export const SvgCamera = (props: SvgProps) => <Svg svg={CameraSvg} {...props} />;
export const SvgDone = (props: SvgProps) => <Svg svg={DoneSvg} {...props} />;
export const SvgDoneNoCircle = (props: SvgProps) => <Svg svg={DoneNoCircleSvg} {...props} />;
export const SvgAppIcon = (props: SvgProps) => <Svg svg={AppIconSvg} {...props} />;
export const SvgLogo = (props: SvgProps) => <Svg svg={CameraSvg} {...props} />;
export const SvgLogoWhite = (props: SvgProps) => <Svg svg={CameraSvg} {...props} />;
export const SvgMenuBurger = (props: SvgProps) => <Svg svg={MenuBurgerSvg} {...props} />;

const Svg = ({
	alt,
	title,
	style,
	className,
	svg,

}: any) => {
	return (
		<img
			style={style}
			className={className}
			alt={alt}
			title={title}
			src={svg}
		/>
	);
}
